// src/pages/DictPage/hooks/useUpgrades.ts
import { useState, useEffect, useCallback } from "react";
import {CreateWeaponUpgradeDto, UpdateWeaponUpgradeDto, WeaponUpgradeFullDto} from "../model/Dto/Dict/WeaponUpgrade";
import {Api} from "../request/api/api";

export function useUpgrades() {
    const [upgrades, setUpgrades] = useState<WeaponUpgradeFullDto[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchUpgrades = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllUpgrades();
            setUpgrades(result);
        } catch (err) {
            setError("Ошибка загрузки списка апгрейдов");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const createUpgrade = useCallback(async (data: CreateWeaponUpgradeDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createUpgrade(data);
            if (result) {
                await fetchUpgrades();
                return true;
            }
            setError("Ошибка создания апгрейда");
            return false;
        } catch (err) {
            setError("Ошибка создания апгрейда");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchUpgrades]);

    const updateUpgrade = useCallback(async (id: string, data: UpdateWeaponUpgradeDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateUpgrade(id, data);
            if (result) {
                await fetchUpgrades();
                return true;
            }
            setError("Ошибка обновления апгрейда");
            return false;
        } catch (err) {
            setError("Ошибка обновления апгрейда");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchUpgrades]);

    const deleteUpgrade = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteUpgrade(id);
            if (result) {
                await fetchUpgrades();
                return true;
            }
            setError("Ошибка удаления апгрейда");
            return false;
        } catch (err) {
            setError("Ошибка удаления апгрейда");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchUpgrades]);

    useEffect(() => {
        fetchUpgrades();
    }, [fetchUpgrades]);

    return {
        upgrades,
        loading,
        error,
        createUpgrade,
        updateUpgrade,
        deleteUpgrade,
        refetch: fetchUpgrades
    };
}